import { Container, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import AuthContainer from "../../../../components/AuthContainer.js";
import BackButton from "../../../../components/BackButton/index.js";
import RegistrationForm from "./RegistrationForm.js";

const RegisterAsCompany = () => {
  const navigate = useNavigate();
  return (
    <AuthContainer>
      <BackButton
        handleBack={() => {
          navigate("/login", { state: { type: "company" } });
        }}
      />
      <Container sx={{ maxWidth: "520px !important", mt: 4 }}>
        <Stack textAlign={"center"}>
          <Typography variant="auth_primary_text" component={"h1"}>
            {t("registration")}
          </Typography>
          <Typography variant="auth_secondary_text" component={"p"}>
            {t("registrationNote")}
          </Typography>
        </Stack>
        <RegistrationForm />
      </Container>
    </AuthContainer>
  );
};

export default RegisterAsCompany;
